export const VIRTUAL_ROW_HEIGHT = 52;
export const NO_DATA_HEADER = 'There is no data for the current selection';

export const NO_DATA_SUBHEADER =
  'If you think that is an error, please get in touch.';
